import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const chiliPiper = defineConnector({
  identifier: "chiliPiper",
  name: "Chili Piper",
  tagLine: "Lead routing and meeting scheduling",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () =>
    "^https://fire\\.chilipiper\\.com/api/fire-edge/v[123]/org/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create a Chili Piper API key",
      items: [
        {
          kind: "markdown",
          content:
            "Ask a Chili Piper admin to open [Command Center](https://fire.chilipiper.com/admin-center) → **Integrations → Credentials → API Access Tokens** and select **Generate Token**. Grant **api.ping** for the connection check, and add only the permissions needed for your requests, such as **Concierge.schedule** for Concierge routing and scheduling. Copy the token immediately; it is shown only once.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "Enter the tenant API key without the Bearer prefix. It must include the api.ping permission.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://fire.chilipiper.com/api/fire-edge/v1/org/health/ping",
      method: "GET",
      expectedStatus: 200,
      expectedBodyContains: "ok",
    }),
  },
  usageHint: () =>
    "Use https://fire.chilipiper.com/api/fire-edge/{version}/org/ with a documented v1, v2, or v3 route. For Concierge, use the router’s Custom API URL and provide form data and options.trigger. Permissions are operation-specific. The API-key MCP endpoint shares this credential boundary; OAuth is not configured.",
});
